export default __webpack_public_path__ + "static/media/codice_comportamento_condotta_Fincantieri_SI_Ita.8f1d2528.pdf";